import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FAQS } from "../data/content";

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faqs" className="vw-section relative bg-[var(--vw-bg-soft)]" data-testid="vw-faq">
      <div className="vw-container">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-14 lg:gap-24">
          <div className="lg:sticky lg:top-32 self-start">
            <div className="vw-eyebrow mb-6">EXECUTIVE FAQ</div>
            <h2 className="font-display text-5xl md:text-6xl leading-[0.92] tracking-tight max-w-[14ch]">
              The questions producers <span className="font-serif-italic font-normal text-[var(--vw-cyan)]">actually ask</span>.
            </h2>
            <p className="mt-6 text-[var(--vw-text-dim)] leading-relaxed max-w-md">
              Anything else — cost breakdowns, security posture, contract terms — we cover on the discovery call.
            </p>
            <a href="#contact" className="vw-btn-ghost mt-8" data-testid="vw-faq-cta">
              Ask on a Call
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
            </a>
          </div>

          <div className="border-t border-[var(--vw-border)]">
            {FAQS.map((f, i) => (
              <div key={f.q} className="border-b border-[var(--vw-border)]" data-testid={`vw-faq-item-${i}`}>
                <button
                  onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
                  className="w-full text-left flex items-start justify-between gap-6 py-6 md:py-7 group vw-focus"
                  data-testid={`vw-faq-toggle-${i}`}
                >
                  <div className="flex items-start gap-6 flex-1">
                    <span className="font-mono text-[10px] uppercase tracking-[0.28em] text-[var(--vw-cyan)] pt-1.5 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <h3 className="font-display text-xl md:text-2xl leading-tight text-[var(--vw-text)] group-hover:text-[var(--vw-cyan)] transition-colors pr-6">
                      {f.q}
                    </h3>
                  </div>
                  <span className="shrink-0 mt-2 relative w-5 h-5">
                    <span className="absolute inset-x-0 top-1/2 h-px bg-[var(--vw-text-dim)] group-hover:bg-[var(--vw-cyan)]" />
                    <motion.span
                      animate={{ rotate: openIdx === i ? 0 : 90 }}
                      transition={{ duration: 0.3 }}
                      className="absolute inset-y-0 left-1/2 w-px bg-[var(--vw-text-dim)] group-hover:bg-[var(--vw-cyan)]"
                    />
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {openIdx === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="pl-14 pb-7 pr-6 text-[var(--vw-text-dim)] leading-relaxed max-w-3xl">
                        {f.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
